import { Paper, Stack, Text } from "@mantine/core";
import { openConfirmModal } from "@mantine/modals";
import { IconTrash } from "@tabler/icons-react";
import { useEffect } from "react";
import { FancyLoader } from "@/components/FancyLoader";
import { Header } from "@/components/Header";
import { NotificationItem } from "@/components/NotificationItem";
import { useNotifications } from "@/hooks/useNotifications";
import { useUser } from "@/UserContext";

export const Notifications = () => {
  const {
    notifications,
    unreadCount,
    isLoading,
    markAsRead,
    deleteNotifications,
  } = useNotifications();

  const user = useUser();

  // Auto mark all as read when component mounts
  useEffect(() => {
    if (unreadCount) {
      markAsRead("all");
    }
  }, [unreadCount, markAsRead]);

  if (isLoading) {
    return (
      <Stack>
        <Header title="Notifications" />
        <FancyLoader />
      </Stack>
    );
  }

  const openModal = () =>
    openConfirmModal({
      title: "Are you sure you want to delete all notifications?",
      labels: { confirm: "Yes", cancel: "Cancel" },
      cancelProps: {},
      onConfirm: () =>
        deleteNotifications(
          notifications.map((notification) => notification.id),
        ),
    });

  return (
    <Stack>
      <Header
        title="Notifications"
        backLink="/"
        actionIcon={<IconTrash onClick={openModal} />}
      />

      {notifications.length === 0 ? (
        <Paper p="xl" withBorder>
          <Text ta="center" c="dimmed" p="lg">
            No notifications
          </Text>
        </Paper>
      ) : (
        <Stack gap="md">
          {notifications.map((notification) => (
            <NotificationItem
              key={notification.id}
              notification={notification}
              onDelete={deleteNotifications}
              role={user.role}
            />
          ))}
        </Stack>
      )}
    </Stack>
  );
};
